import FileTagsService from '../../../services/FileTagsService';
import { getFileTagsError, getFileTagsSuccess } from './actions';
import { GET_LIST_FILE_TAGS } from './actionTypes';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

const getFileTagsAsync = async (pagination) => {
  return await FileTagsService.getList(pagination);
};

function* getFileTags({ payload }) {
  try {
    const response = yield call(getFileTagsAsync, payload);

    yield put(getFileTagsSuccess(response));
  } catch (error) {
    yield put(getFileTagsError(error));
  }
}

export function* watchfileTagsList() {
  yield takeEvery(GET_LIST_FILE_TAGS, getFileTags);
}


function* fileTagsSaga() {
  yield all([
    fork(watchfileTagsList),
  ]);
}

export default fileTagsSaga;